{
  "distance_activator_label": "Distance",
  "distance_miles": "{count} miles",
  "distance_any": "Any Distance",
  "distance_within": "Within",
  "distance_summary": "Within {distance} of {location}",
  "distance_popular_locations": "Popular Locations",
  "distance_search_results": "Search Results",
  "distance_maximum": "Maximum distance (miles)",
  "distance_label": "Distance in Miles",
  "insurance_no_plans": "No plans available.",
  "insurance_search": "Search",
  "visit_type_title": "Visit types offered",
  "visit_type_any": "Any visit type",
  "visit_type_toggle": "Toggle visit types in this category",
  "options_unavailable": "These options could not be loaded. Please try again later.",
  "specialty_toggle": "Toggle subspecialties",
  "provider_named": "named",
  "provider_noun": "provider",
  "provider_accepting": "I'm looking for",
  "provider_name": "Provider's Name",
  "provider_name_placeholder": "Enter doctor's name",
  "provider_type": "Provider Type",
  "provider_type_placeholder": "All Types",
  "provider_affiliation": "Affiliation",
  "provider_affiliation_placeholder": "Any affiliation",
  "provider_new": "A new provider",
  "provider_returning": "A provider I've seen before",
  "provider_any": "Any provider",
  "specialty_search": "Search specialties & conditions",
  "distance_title": "Near",
  "distance_search": "City, address, or zip code",
  "current_location": "Use my location",
  "current_location_display": "Current Location",
  "current_location_retrieving": "Retrieving current location",
  "current_location_error": "An error occurred when trying to detect your current location. Please search for your location instead.",
  "clear": "Clear",
  "search_placeholder": "Type to search",
  "no_results": "No results found",
  "multiple_selected": "{count} selected"
}
